export default {
  welcome: {
    complete: '/welcome',
  },
  signup: {
    complete: '/signup',
  },
  logout: {
    complete: '/logout',
  },
  modelPortfolios: {
    complete: '/model-portfolios',
    details: '/model-portfolios/:modelPortfolioId',
  },
  accounts: {
    profiling: {
      // create account
      base: '/accounts/profiling',
      complete: '/accounts/profiling/welcome',
      type: {
        complete: '/accounts/profiling/type',
      },
      createNew: {
        complete: '/accounts/profiling/create-new',
      },
      // with account
      withAccount: {
        complete: '/accounts/:accountId/profiling',
      },
      ownerInfo: {
        complete: '/accounts/:accountId/profiling/owner-info',
      },
      investmentPrologue: {
        complete: '/accounts/:accountId/profiling/investment-prologue',
      },
      investment: {
        complete: '/accounts/:accountId/profiling/investment',
      },
      objectivesPrologue: {
        complete: '/accounts/:accountId/profiling/objectives-prologue',
      },
      objectivesType: {
        complete: '/accounts/:accountId/profiling/objectives-type',
      },
      objectives: {
        retirement: { complete: '/accounts/:accountId/profiling/objectives/retirement' },
        safetyNet: { complete: '/accounts/:accountId/profiling/objectives/safety-net' },
        expense: { complete: '/accounts/:accountId/profiling/objectives/expense' },
        genericInvestment: {
          complete: '/accounts/:accountId/profiling/objectives/generic-investment',
        },
        complete: '/accounts/:accountId/profiling/objectives',
      },
      assets: {
        complete: '/accounts/:accountId/profiling/assets',
      },
      liabilities: {
        complete: '/accounts/:accountId/profiling/liabilities',
      },
      insights: {
        complete: '/accounts/:accountId/profiling/insights',
        instruments: {
          all: { complete: '/accounts/:accountId/profiling/insights/instruments/all' },
          etfs: { complete: '/accounts/:accountId/profiling/insights/instruments/etfs' },
          funds: { complete: '/accounts/:accountId/profiling/insights/instruments/funds' },
        },
        keywords: {
          return: { complete: '/accounts/:accountId/profiling/insights/keywords/return' },
          maxDrawdown: {
            complete: '/accounts/:accountId/profiling/insights/keywords/max-drawdown',
          },
          volatility: {
            complete: '/accounts/:accountId/profiling/insights/keywords/volatility',
          },
          var: { complete: '/accounts/:accountId/profiling/insights/keywords/var' },
        },
      },
      experience: {
        complete: '/accounts/:accountId/profiling/experience',
        part1: { complete: '/accounts/:accountId/profiling/experience/1' },
        part2: { complete: '/accounts/:accountId/profiling/experience/2' },
        part3: { complete: '/accounts/:accountId/profiling/experience/3' },
        part4: { complete: '/accounts/:accountId/profiling/experience/4' },
      },
      strategy: {
        complete: '/accounts/:accountId/profiling/strategy',
        return: {
          complete: '/accounts/:accountId/profiling/strategy/return',
        },
        maxDrawdown: {
          complete: '/accounts/:accountId/profiling/strategy/max-drawdown',
        },
        volatility: {
          complete: '/accounts/:accountId/profiling/strategy/volatility',
        },
      },
      riskAppetite: {
        complete: '/accounts/:accountId/profiling/risk-appetite',
      },
      riskProfile: {
        complete: '/accounts/:accountId/profiling/risk-profile',
      },
    },
    complete: '/accounts',
    details: '/accounts/:accountId',
    create: {
      complete: '/accounts/create',
    },
    welcome: {
      complete: '/accounts/welcome',
    },
    profile: {
      complete: '/accounts/:accountId/profile',
    },
    infos: {
      complete: '/accounts/:accountId/infos',
      personal: {
        complete: '/accounts/:accountId/infos/personal',
      },
      contacts: {
        complete: '/accounts/:accountId/infos/contacts',
        edit: {
          complete: '/accounts/:accountId/infos/contacts/edit',
        },
      },
      addresses: {
        complete: '/accounts/:accountId/infos/addresses',
        edit: {
          complete: '/accounts/:accountId/infos/addresses/edit/:addressId',
        },
        add: {
          complete: '/accounts/:accountId/infos/addresses/add',
        },
      },
      documents: {
        complete: '/accounts/:accountId/infos/documents',
        edit: {
          complete: '/accounts/:accountId/infos/documents/edit/:documentId',
        },
        add: {
          complete: '/accounts/:accountId/infos/documents/add',
        },
      },
      ppe: {
        complete: '/accounts/:accountId/infos/ppe',
      },
      taxScheme: {
        complete: '/accounts/:accountId/infos/tax-scheme',
      },
      amlProfile: {
        complete: '/accounts/:accountId/infos/aml-profile',
        aml: {
          complete: '/accounts/:accountId/infos/aml-profile/aml',
        },
        pep: {
          complete: '/accounts/:accountId/infos/aml-profile/pep',
        },
      },
    },
    contract: {
      complete: '/accounts/:accountId/contract',
    },
    createDepositAccount: {
      complete: '/accounts/:accountId/create-deposit-account',
      prologue: {
        complete: '/accounts/:accountId/create-deposit-account/prologue',
      },
      instructions: {
        complete: '/accounts/:accountId/create-deposit-account/instructions',
      },
    },
    verification: {
      complete: '/accounts/:accountId/verification',
    },
    dashboard: {
      complete: '/accounts/:accountId/dashboard',
    },
    portfolioQadra: {
      complete: '/accounts/:accountId/portfolio-qadra',
      details: '/accounts/:accountId/portfolio-qadra/:portfolioId',
    },
    portfolios: {
      complete: '/accounts/:accountId/portfolios',
      details: '/accounts/:accountId/portfolios/:portfolioId',
    },
    investments: {
      complete: '/accounts/:accountId/investments',
      details: '/accounts/:accountId/investments/:portfolioId',
    },
    documents: {
      complete: '/accounts/:accountId/documents',
    },
    wallet: {
      complete: '/accounts/:accountId/wallet',
    },
    portfolioProposals: {
      complete: '/accounts/:accountId/portfolio-proposals',
      details: '/accounts/:accountId/portfolio-proposals/:proposalId',
      compare: {
        complete: '/accounts/:accountId/portfolio-proposals/compare',
      },
    },
  },
  profile: {
    complete: '/profile',
    info: {
      complete: '/profile/info',
      edit: {
        complete: '/profile/info/edit',
      },
    },
    addresses: {
      complete: '/profile/addresses',
      edit: {
        complete: '/profile/addresses/edit/:addressId',
      },
      add: {
        complete: '/profile/addresses/add',
      },
    },
    documents: {
      complete: '/profile/documents',
      edit: {
        complete: '/profile/documents/edit/:documentId',
      },
      add: {
        complete: '/profile/documents/add',
      },
    },
    contacts: {
      complete: '/profile/contacts',
      edit: {
        complete: '/profile/contacts/edit',
      },
    },
  },
};
